import React from 'react';
import { FormattedMessage } from 'react-intl';
import DashboardLayout from './../layout/Dashboard';
import { Messages } from "../../components/layout/Messages/Messages";
import { NOTIFICATION_TICKETS_ACTIONS} from '../../config/notifications';
import { ACL } from '../../config/constants';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import {
  TicketsTableComponent
} from '../../components/pages/tickets/TicketsTable';
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './Tickets.scss';

function TicketsComponent(props) {

  return (
    <DashboardLayout
      pageTitle={<FormattedMessage id="app.dashboard.page_title"/>}
      workspace
      {...props}
    >
      <PageWorkspace className="tickets-list-workspace">
        <PageHeader title={<FormattedMessage id="pages.tickets.title"/>}/>
        <div className="tickets-list-notifications">
          <Messages/>
          <Messages notificationId={NOTIFICATION_TICKETS_ACTIONS}/>
        </div>
        <PageSurface className="tickets-list-surface">
          {! ACL.CLIENT.TICKETS.MANAGE.hasAccess() ? <NoRights/> :
            <TicketsTableComponent/>}
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  )
}

export { TicketsComponent };
